import { SaleOrderItem } from '@/util/services/cart/api.type';
import { pushGtmEvent } from './gtm-data-layer';

export interface GtmCartItem {
    item_sku: string;
    item_name: string;
    item_handle: string;
    price: number;
    quantity: number;
}

// Build a GTM line item from a cart SaleOrderItem.
// `quantity` is the amount being added/removed (the delta) — NOT the resulting
// line quantity — so add_to_cart / remove_from_cart report the change, matching
// the field shape used by the `purchase` event (see GtmPurchaseEvent).
export function buildGtmCartItem(
    item: SaleOrderItem,
    quantity: number,
    loc: string,
): GtmCartItem {
    const localeUpper = (loc || 'th').toUpperCase();
    const attr =
        item.msProduct?.attributes?.find((a) => a.loc === localeUpper) ??
      item.msProduct?.attributes?.[0];
    return {
        item_sku: item.msProductVariant?.SKU ?? '',
        item_name: attr?.displayName ?? '',
        item_handle: item.msProductHandle ?? '',
        price: item.price ?? item.msProductVariant?.priceFull ?? 0,
        quantity,
    };
}

export function pushAddToCart(
    items: GtmCartItem[],
    currencyCode: string,
): void {
    if (items.length === 0) return;
    pushGtmEvent({
        event: 'add_to_cart',
        ecommerce: {
            currency: currencyCode || 'THB',
            items,
        },
    });
}

export function pushRemoveFromCart(
    items: GtmCartItem[],
    currencyCode: string,
): void {
    if (items.length === 0) return;
    pushGtmEvent({
        event: 'remove_from_cart',
        ecommerce: {
            currency: currencyCode || 'THB',
            items,
        },
    });
}
